import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthModal from "../AuthModal/AuthModal";
import { track } from "@vercel/analytics";
import HeroScoreboard from "./HeroScoreboard";
import { HERO_H1, HERO_SUB } from "../../utility/aiAssistCopy";

const jobs = [
  {
    title: "Fill the squads",
    body: "Bowlers sign up for a squad. You review who is on each squad. The squad locks when it is full.",
  },
  {
    title: "Post the scores",
    body: "Enter games as they bowl. Scratch and handicap on one sheet. The public board updates. No spreadsheet to email afterward.",
  },
  {
    title: "Pay the board",
    body: "Prize funds and side pots on one payout table. Lock the payouts. Bowlers see the same numbers you posted.",
    to: "/bowling-payout-calculator",
    linkLabel: "Payout calculator",
  },
];

const HeroSection = ({
  boardTournament = null,
  boardRows = [],
  prizeFund = null,
  loading = false,
  live = false,
}) => {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleRunTournament = (e) => {
    track("create_tournament_click", { location: "hero_section" });
    if (!user) {
      e.preventDefault();
      setShowAuthModal(true);
    }
  };

  return (
    <div className="bg-brand-charcoal text-brand-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <p className="text-brand-mist font-display tracking-widest uppercase text-sm mb-3">
              Bowling Tournament App
            </p>
            <h1 className="font-display font-bold tracking-tight text-4xl md:text-5xl text-brand-cream leading-tight">
              {HERO_H1}
            </h1>
            <p className="mt-4 text-base md:text-lg text-brand-mist max-w-xl">
              {HERO_SUB}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/create-tournament"
                onClick={handleRunTournament}
                className="btn-brand md:px-8 md:py-3"
              >
                Run a tournament
              </Link>
              <Link
                to="/tournaments"
                onClick={() =>
                  track("browse_tournaments_click", { location: "hero_section" })
                }
                className="inline-flex items-center justify-center rounded-lg bg-brand-cream text-brand-charcoal font-display font-bold tracking-wide px-4 py-2 md:px-8 md:py-3 hover:bg-white transition-colors"
              >
                Find tournaments
              </Link>
            </div>
          </div>

          <HeroScoreboard
            tournament={boardTournament}
            rows={boardRows}
            live={live}
            prizeFund={prizeFund}
            loading={loading}
          />
        </div>

        <div className="mt-14 md:mt-16 pt-10 border-t border-brand-line grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {jobs.map((job) => (
            <div key={job.title}>
              <h2 className="font-display font-bold tracking-tight text-2xl md:text-3xl text-brand-cream">
                {job.title}
              </h2>
              <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
              <p className="mt-4 text-brand-mist text-base leading-relaxed">
                {job.body}
              </p>
              {job.to ? (
                <p className="mt-3">
                  <Link
                    to={job.to}
                    onClick={() =>
                      track("payout_calculator_cta_click", {
                        location: "homepage",
                        action: "calculator",
                      })
                    }
                    className="text-brand-cream underline hover:text-brand-mist"
                  >
                    {job.linkLabel}
                  </Link>
                </p>
              ) : null}
            </div>
          ))}
        </div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />
    </div>
  );
};

export default HeroSection;
